import JSCookie from 'js-cookie';

import 'core/helpers/browser';
import 'core/helpers/build-info';

import {$compile} from 'core/core';
import {handleLangCookies} from 'core/helpers/common-cookies';

import './compilers/core.compiler';
import './compilers/gn.compiler';
import './compilers/forms.compiler';

window.Cookies = JSCookie;

export const initCore = () => {
  handleLangCookies();

  $compile(document.body, 'core');
  $compile(document.body, 'gn');
  $compile(document.body, 'forms');
};
